/** For use with react-dnd */ export var DraggableType// TODO: Figure out a decent way to type DND payloads
;
(function(DraggableType) {
    DraggableType[/** Expects an `id` field to be provided */ "MEDIA_MANAGER_GALLECTION"] = 'mm-gallection';
    DraggableType["MEDIA_MANAGER_SLIDER_GALLECTION"] = 'mm-slider-gallection';
    DraggableType["MEDIA_MANAGER_DEVIATION"] = 'mm-deviation';
    DraggableType[/** Expects a `deviation` field to be provided */ "DEVIATION"] = 'deviation';
    DraggableType[/** Expects an `id` field to be provided */ "BADGE"] = 'badge';
    DraggableType["BADGE_FEATURED"] = 'badgefeatured';
})(DraggableType || (DraggableType = {}));
